import React from 'react';
import ProfileLayout from './ProfileLayout';
import { FigmaTokensPanel } from '../figma/FigmaTokensPage';

// The Figma plugin token section of Settings.
//
// Its own route rather than a block on the account page: a token is a credential a designer is
// sent to fetch ("open Settings → Figma plugin token"), and that instruction needs a link to point
// at. The route is what makes the link possible.
export default function FigmaTokenSettingsPage() {
  return (
    <ProfileLayout>
      <div>
        <h2 className="text-sm font-bold text-ink mb-1">Figma plugin token</h2>
        <p className="text-xs text-ink-dim mb-4 font-medium">
          The design plugin needs a token to talk to this service. It is yours alone: it names you
          on everything you push, and you can revoke it for one machine without affecting anyone
          else. Never share it — a colleague mints their own here.
        </p>
        <FigmaTokensPanel />
      </div>
    </ProfileLayout>
  );
}
